// extracted by mini-css-extract-plugin
module.exports = {"link":"_3JZW3","placeholder":"OIs90"};